import _ from 'lodash';
import React, {Component} from 'react';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  Title,
  Button
} from 'components/landing/components';

import './Price.css';


let dumbPrice = dumbBem('l-pricing-price');
let PriceWrp = tx(dumbPrice)('div');


export class Price extends Component {
  render() {
    return (
      <PriceWrp>
        {
          _.isNumber(this.props.price) ?
            <React.Fragment>
              <Title modifier='heading'>{this.props.heading}</Title>
              <Title modifier='price'>{`$${this.props.price || ''}`}</Title>
              <Title modifier='period'>{`/${this.props.period || ''}`}</Title>
            </React.Fragment> : <Button modifier='reversed-colors'>{this.props.price}</Button>
        }

      </PriceWrp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/pages/pricing/price/Price.js